import { ReactNode, useEffect } from 'react';

import { useGlobalFilterQuery } from '../../hooks/filter';
import { useStore } from '../../store';
import { FilterConfigDto } from '../../store/states/filterTypes';
import { InvestorSelector } from '../investorselection/InvestorSelector';

import { ApplicationNavSection } from './ApplicationNavSection';
import { DetailsPageNavSection } from './DetailsPageNavSection';
import { NavigationGlobalFilters } from './NavigationGlobalFilters';

import styles from './navigation.module.scss';

type NavigationProps = {
  applicationSwitcher?: ReactNode;
  globalFilters?: FilterConfigDto[];
  rootPageId?: string;
  userMenuButton: ReactNode;
};

export const Navigation: React.FC<NavigationProps> = ({
  applicationSwitcher,
  globalFilters,
  rootPageId,
  userMenuButton,
}) => {
  const collapsed = useStore((state) => state.isNavigationCollapsed);

  const globalFilterResult = useGlobalFilterQuery(globalFilters, rootPageId);

  useEffect(() => {
    document.body.classList.toggle('with-sidebar--open', !collapsed);
    document.body.classList.toggle('with-sidebar--closed', collapsed);
  }, [collapsed]);

  return (
    <>
      {collapsed ? (
        <div className={styles.user}>
          {userMenuButton}
          {applicationSwitcher}
        </div>
      ) : (
        <>
          <InvestorSelector className={styles['investor-selection']} />
          <NavigationGlobalFilters
            globalFilters={globalFilters}
            rootPageId={rootPageId}
            globalFilterResult={globalFilterResult}
          />
        </>
      )}
      <ApplicationNavSection />
      <DetailsPageNavSection />
    </>
  );
};
